import * as React from 'react'
import { Heading as StyledHeading } from '@chakra-ui/core'
import { HeadingProps as _HeadingProps } from '@chakra-ui/core/dist/Heading'
import { TextProps } from '../text'
import { textStyles } from '../../base/typography'

interface HeadingProps extends TextProps {}

const Heading: React.FC<HeadingProps> = (props: HeadingProps): React.ReactElement => {
	const {
		variant,
		...rest
	} = props

	let textProps: any = {}
	if (variant && textStyles[variant]) {
		textProps = textStyles[variant]
	}

	return <StyledHeading fontFamily="heading" fontWeight="bold" lineHeight="none" {...textProps} {...rest} />
}

export { HeadingProps }

export default Heading
